import axiosRequestInterceptor from '../interceptor/axiosAPIRequestInterceptor';
import { logger } from '../utils/logger';

export const getUserKcCardData = async (userId) => {
	try {
		const response = await axiosRequestInterceptor.post(`/myPath/loadUserKcCardData`, {
			userId,
		});
		logger.log('Response from getUserKcCardData: ', response?.data?.data);
		return { data: response?.data?.data };
	} catch (error) {
		const status = error?.response?.status;
		const message = error?.response?.data?.message || 'Unexpected error';

		// Optional: Customize based on status code
		if (status === 404) {
			logger.warn('No KC path data found for user');
		} else if (status === 500) {
			logger.error('Server error:', error?.response?.data?.error);
		}

		return {
			error: message,
			data: { READING_WRITING: [], MATHS: [] }, // fallback empty structure
		};
	}
};

export const saveUserKcPathData = async (userId, cardsRW, cardsM) => {
	try {
		const response = await axiosRequestInterceptor.post(`/myPath/saveUserKcPathData`, {
			userId,
			cardsRW,
			cardsM,
		});
		logger.log('Response from saveUserKcPathData: ', response?.data?.data);
		return { data: response?.data?.message };
	} catch (error) {
		const message = error?.response?.data?.message || 'Something went wrong';
		return { error: message, data: [] };
	}
};

export const addSIngleCardToMyPath = async (userId, section, newCard) => {
	try {
		const response = await axiosRequestInterceptor.post('/myPath/addSIngleCardToMyPath', {
			userId,
			section,
			newCard,
		});
		logger.log('Response from saveUserKcPathData: ', response?.data?.data);
		return { data: response?.data?.message };
	} catch (error) {
		const message = error?.response?.data?.message || 'Something went wrong';
		return { error: message, data: null };
	}
};
